<template>
  <div>
    <a-modal :centered="true" :width="650" :dialog-style="{ margin: '0px', width: '650px !important' }" v-model="showModal" :footer="null" title="Notifications" @ok="() => (showModal = false)">
      <div class="notification-modal">
        <div class="notification-modal-view" :style="{ color: getPrimaryColor() }" @click="handleRouteViewAll">View all</div>
        <div class="notification-modal-list">
          <div class="notification-modal-list__today">
            <div class="mb-2 notification-modal-list--header">Today</div>
            <div>
              <div
                v-for="(notification, index) in todayNoti"
                :key="index"
                :style="{
                  background: !notification.is_read ? '#dfe7f5' : '#faf8f8',
                  width: '100%',
                }"
              >
                <div class="d-flex mr-4 mb-3 pt-2" :style="{ height: '90px' }" @click="() => notificationRouter(notification)">
                  <template v-if="!hideNotiUser(notification.notification_text)">
                    <a-avatar
                      :style="{
                        color: ' #ffffff !important',
                        'background-color': notification.sender_user[0].length ? notification.sender_user[0][0].url : '' ? '' : '#C997C5',
                      }"
                      :size="60"
                      class="post-list-image round-img small-avatar-image ml-2 text-capitalize"
                      :src="notification.sender_user[0].length ? notification.sender_user[0][0].url : ''"
                    >
                      {{
                        notification.sender_user[0].firstName
                          ? notification.sender_user[0].firstName[0]
                          : notification.sender_user[0].display_name
                          ? notification.sender_user[0].display_name[0]
                          : notification.sender_user[0].first_name[0]
                      }}
                    </a-avatar>
                    <div class="notification-content">
                      <div class="notif-text mb-0">
                        <div v-if="notification.sender_user.length">
                          <span
                            :style="{
                              'font-weight': '700',
                              'line-height': '24px',
                            }"
                            class="text-truncate text-capitalize"
                          >
                            {{
                              ["doctor", "physician", "hcp", "ahcp", "ohcp", "other"].includes(notification.sender_user[0].role) && notification.notification_text === "added you to circle"
                                ? `Doctor ${notification.sender_user[0].display_name}`
                                : notification.sender_user[0].display_name
                            }}
                            <!-- {{ notification.sender_user[0].display_name }} -->
                          </span>
                        </div>
                        <p class="mb-0">
                          <!-- {{ notification.notification_text }} -->
                          {{
                            getNewNotificationText(
                              notification.notification_text,
                              notification.sender_user[0].display_name,
                              notification.sender_user[0].role,
                              notification.sender_user[0].gender,
                              notification.receiver_user[0].role
                            )
                          }}
                        </p>
                      </div>
                      <p class="notif-text-small mb-0">
                        {{ formatPostTime(notification.notification_time)[0] }}
                      </p>
                    </div>
                  </template>
                  <template v-else>
                    <p class="m-auto gray800 text-capitalize font16 mb-2">
                      {{
                        getNewNotificationText(
                          notification.notification_text,
                          notification.sender_user[0].display_name,
                          notification.sender_user[0].role,
                          notification.sender_user[0].gender,
                          notification.receiver_user[0].role
                        )
                      }}
                    </p>
                    <p class="notif-text-small mb-0">
                      {{ formatPostTime(notification.notification_time)[0] }}
                    </p>
                  </template>
                </div>
              </div>
            </div>

            <div class="empty-text" v-if="!isToday">No New Notifications</div>
          </div>
          <div class="notification-modal-list__earlier">
            <div class="mb-2 notification-modal-list--header">
              <div class="mb-2">Earlier</div>
              <div v-if="earlierNoti.length">
                <div
                  v-for="(notification, index) in earlierNoti"
                  :key="index"
                  :style="{
                    background: !notification.is_read ? '#dfe7f5' : '#faf8f8',
                    width: '100%',
                  }"
                >
                  <div class="d-flex mr-4 mb-3 pt-2" :style="{ height: '90px' }" @click="() => notificationRouter(notification)">
                    <template v-if="!hideNotiUser(notification.notification_text)">
                      <a-avatar
                        :style="{
                          color: ' #ffffff !important',
                          'background-color': notification.sender_user.length ? notification.sender_user[0].url : '' ? '' : '#C997C5',
                        }"
                        :size="60"
                        class="post-list-image round-img small-avatar-image ml-2 text-capitalize"
                        :src="notification.sender_user.length ? notification.sender_user[0].url : ''"
                      >
                        {{
                          notification.sender_user[0].firstName
                            ? notification.sender_user[0].firstName[0]
                            : notification.sender_user[0].display_name
                            ? notification.sender_user[0].display_name[0]
                            : notification.sender_user[0].first_name[0]
                        }}
                      </a-avatar>
                      <div class="notification-content">
                        <div class="notif-text mb-0">
                          <div v-if="notification.sender_user.length">
                            <span
                              :style="{
                                'font-weight': '700',
                                'line-height': '24px',
                              }"
                              class="text-truncate text-capitalize"
                            >
                              {{
                                ["doctor", "physician", "hcp", "ahcp", "ohcp", "other"].includes(notification.sender_user[0].role) && notification.notification_text === "added you to circle"
                                  ? `Doctor ${notification.sender_user[0].display_name}`
                                  : notification.sender_user[0].display_name
                              }}
                              <!-- {{ notification.sender_user[0].display_name }} -->
                            </span>
                          </div>
                          <p class="mb-0">
                            <!-- {{ notification.notification_text }} -->
                            {{
                              getNewNotificationText(
                                notification.notification_text,
                                notification.sender_user[0].display_name,
                                notification.sender_user[0].role,
                                notification.sender_user[0].gender,
                                notification.receiver_user[0].role
                              )
                            }}
                          </p>
                        </div>
                        <p class="notif-text-small mb-0">
                          {{ formatPostTime(notification.notification_time)[0] }}
                        </p>
                      </div>
                    </template>
                    <template v-else>
                      <p class="m-auto gray800 text-capitalize font16 mb-2">
                        {{
                          getNewNotificationText(
                            notification.notification_text,
                            notification.sender_user[0].display_name,
                            notification.sender_user[0].role,
                            notification.sender_user[0].gender,
                            notification.receiver_user[0].role
                          )
                        }}
                      </p>
                      <p class="notif-text-small mb-0">
                        {{ formatPostTime(notification.notification_time)[0] }}
                      </p>
                    </template>
                  </div>
                </div>
              </div>

              <div class="empty-text" v-if="!isEarli">No Old Notifications</div>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { eventBus } from "../../main"
import { RepositoryFactory } from "../../repositories/RepositoryFactory"
import moment from "moment"
const AppRepository = RepositoryFactory.get("app")

export default {
  name: "NotificationModal",
  data() {
    return {
      showModal: false,
      notification: [],
      todayNoti: [],
      earlierNoti: [],
      isEarli: false,
      isToday: false,
      currentPage: 1,
      limit: 5,
    }
  },
  methods: {
    show() {
      this.showModal = true
      this.fetchNotifications()
    },
    hide() {
      this.showModal = false
    },
    handleRouteViewAll() {
      this.$router.push({ name: "Notification" })
      this.hide()
    },
    fetchNotifications() {
      AppRepository.getNotifications(this.currentCircle.id, this.currentPage, this.limit, this.authUser.user)
        .then(res => {
          let userNotifications = res.data.data.data
          this.unreadNotificationCount = 0
          if (userNotifications) {
            userNotifications.map(ele => {
              if (ele.is_read === false) {
                this.unreadNotificationCount += 1
              }
            })
          }
          console.log(this.unreadNotificationCount, "unread count lenth")
          this.todayNoti = userNotifications.filter(x => {
            return moment(x.notification_time).dayOfYear() == moment().dayOfYear()
          })
          this.earlierNoti = userNotifications.filter(x => {
            return moment(x.notification_time).dayOfYear() !== moment().dayOfYear()
          })
          this.isToday = this.todayNoti.length > 0 ? true : false
          this.isEarli = this.earlierNoti.length > 0 ? true : false
          console.log(this.todayNoti, this.earlierNoti, "today earlier noti")
          this.pagination = res.data.data.paginator
        })
        .catch(err => console.error(err))
    },
    notificationRouter(data) {
      console.log(data, "notification data")
      const id = data.ext_red_id ? data.ext_red_id : data.id

      AppRepository.readNotifications(id).then(res => {
        if (data.element_type) {
          let rout = data.element_type
          this.$router.push({ name: "Notification" })
          if (rout == "add to circle") {
            this.viewProfile(data.sender_user[0])
          } else if (data.element_type === "post") {
            this.$router.push({ path: `home/view/post/${data.element_id}` })
          } else if (data.element_type === "question") {
            this.$router.push({ path: `home/qa/share/${data.element_id}` })
          } else if (data.element_type === "poll") {
            this.$router.push({
              path: `home/resources/poll/${data.element_id}`,
            })
          } else if (data.element_type === "trivia") {
            this.$router.push({
              path: `home/resources/trivia/${data.element_id}`,
            })
          } else if (data.element_type === "slideshow") {
            this.$router.push({
              path: `home/resources/slideshow/${data.element_id}`,
            })
          } else {
            this.viewProfile(data.sender_user[0])
          }
          //this.$router.push({ path: `home/view/post/${data.element_id}/about` });
          // console.log(rout,"rout")
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.notification-modal {
  min-height: 85vh;

  &-view {
    font-size: 16px;
    line-height: 24px;
    font-weight: bold;
    cursor: pointer;
    text-align: end;
    margin-bottom: 20px;
  }

  &-list {
    &--header {
      font-weight: 700;
      font-size: 16px;
    }
    .empty-text {
      font-weight: 700;
      font-size: 16px;
      text-align: center;
      margin-top: 10px;
    }
    &__today {
      min-height: 15vh;
    }
  }
}
.notification-content {
  margin-left: 10px;
  font-size: 14px;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/NotificationModal.vue